import { render, staticRenderFns } from "./Step10.vue?vue&type=template&id=0b6526d8&"
import script from "./Step10.vue?vue&type=script&lang=js&"
export * from "./Step10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports